import {Text} from "@hosttools/frontend/components";
import type {ComponentProps} from "react";
import type React from "react";
import {memo} from "react";

const Heading: React.FC<ComponentProps<typeof Text>> = ({
    color = "blueGray.800",
    variant = "xl",
    ...rest
}) => {
    return <Text {...rest} isHeading color={color} variant={variant} />;
};

export default memo(Heading);
